"use client";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useState } from "react";
import { Link } from "@/components/CustomLink";
import { ContactCardProps } from "@/components/views/about/types";
import ContactModal from "@/components/views/modals/contact/ContactModal";
import AuthModal from "../../modals/auth/AuthModal";
import { useTranslation } from "@/hooks/translationContext";

export default function ContactCard(props: ContactCardProps) {
  const { t } = useTranslation();
  const { title, text, buttons, background } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpen, setOpen] = useState(false);

  return (
    <div className={background}>
      <ContactModal isOpen={isOpen} setOpen={setOpen} />

      <div className="flex p-6 md:max-w-[384px] min-h-[210px] border border-gray flex-col justify-center content-around rounded-3xl">
        <h2 className="justify-center items-center justify-items-center flex py-1.5 text-primary text-[16px] font-bold">
          {title}
        </h2>
        <div className="p-2 self-stretch content-center flex flex-col">
          <p className="text-sm/[22px] font-medium text-primary">{text}</p>
        </div>
        <div className="flex gap-2">
          {Array.isArray(buttons) &&
            buttons.map((button, index) => {
              return (
                <>
                  {button.href ? (
                    <Link
                      href={`${button.href}`}
                      className="w-full"
                      key={index}
                    >
                      <Button
                        key={index}
                        onClick={() => {
                          if (title == t("contact-page-title")) {
                            setOpen(true);
                          }
                        }}
                        className={cn(
                          "w-full justify-between text-center",
                          index && "!justify-center",
                        )}
                        variant={button.variant as any}
                        size="lg"
                      >
                        {button.label}
                      </Button>
                    </Link>
                  ) : (
                    <>
                      <AuthModal
                        initialModal="signup"
                        isOpened={isModalOpen}
                        closer={() => setIsModalOpen(false)}
                      />

                      <Button
                        onClick={() => {
                          if (button.onClick) {
                            button.onClick();
                          } else setIsModalOpen(true);
                        }}
                        key={index}
                        className={cn(
                          "w-full text-center",
                          index ? "justify-center" : "justify-between",
                        )}
                        variant={button.variant as any}
                        size="lg"
                      >
                        {button.label}
                      </Button>
                    </>
                  )}
                </>
              );
            })}
        </div>
      </div>
    </div>
  );
}
